class PropertyApi {

  constructor(authToken) {
    this.authToken = authToken;
  }

  headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  BASE_URL = 'https://d2bazeiz5asygt.cloudfront.net/property';

  createHeaders() {
    return this.authToken ? {
      ...this.headers,
      'Authorization': 'Bearer ' + this.authToken
    } : this.headers;
  }

  async searchByAddress(address, page = 0, size = 20) {
    const params = new URLSearchParams({address, page, size});
    return await fetch(`${this.BASE_URL}/searchByAddress?${params.toString()}`, {
      method: 'GET',
      headers: this.createHeaders()
    });
  }

  async suggestAddress(address) {
    return await fetch(`${this.BASE_URL}/suggestAddress?address=${encodeURIComponent(address)}`, {
      method: 'GET',
      headers: this.createHeaders()
    });
  }

  async findById(id) {
    return await fetch(`${this.BASE_URL}/findById?propertyId=${id}`, {
      method: 'GET',
      headers: this.createHeaders()
    });
  }
}

export default PropertyApi;